import { render, staticRenderFns } from "./ReportCompaniesDocument.vue?vue&type=template&id=65024111&scoped=true"
import script from "./ReportCompaniesDocument.vue?vue&type=script&lang=js"
export * from "./ReportCompaniesDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65024111",
  null
  
)

export default component.exports